export default "__VITE_ASSET__A0y4ueIw__"